import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ImageSearchIcon(props: IconProps) {
    return <Icon {...props} iconKey={"image_search"}/>
}
